import React from "react";
import { useParams } from "react-router-dom";
import Test from "../Test/Test";

function TestWrapper(props) {

    const { slug } = useParams();

    return (
        <Test
            {...props}
            slug={props.slug ?? slug}
        />
    );
}

export default React.memo(TestWrapper);